module.exports = __webpack_public_path__ + "static/media/MinPrice.fb7aeb82.svg";